
/*@ngInject*/
const TaskCalendarFocusDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm, $attrs) {

        if ($attrs.toggleFocus === 'false') {
            $timeout(function () {
                $scope.$broadcast('uib:datepicker.focus');
            });
        } else {
            $($elm).siblings()[0].focus();
        }
    };

    return {
        restrict: 'AC',
        link: linkFunction
    };
};

angular.module('gw-um-submission')
    .directive('taskCalendarFocus', TaskCalendarFocusDirective);
